export const GOOGLE_API = {
    CLIENT_ID: '729159686220-m5j85d870vu9grm1mugvu2bntk6muhqn.apps.googleusercontent.com',
    CLIENT_SECRET: 'O7SlGCXNHkY9XgJSMzNsCols',
    API_KEY: 'AIzaSyCvpmKNr2-LF8iieDAwKUwfP3LWtdgB2MI',
    MAPS_API_KEY: 'AIzaSyBdQA028scrdlzI3sD2uPsRK5qrUxN2ocA',
    DISCOVERY_DOCS: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
    SCOPES: 'https://www.googleapis.com/auth/calendar.events'
}

export const PATHS = {
    HOME: '/',
    TERMS_AND_CONDITIONS: '/TerminosyCondiciones',
    SURVEY_ASSIGNED: '/encuesta_asignada'
}

export const MAIN_NODES = {
    USERS: 'users',
    COMPANIES: 'companies',
    SURVEYS_ASSIGNED: 'surveysAssigned',
    SURVEYS_SOLVED: 'surveysSolved',
    PROCEDURES: 'procedures',
    HISTORICAL_PROCEDURES: 'historicalProcedure',
    INVENTORY_RESERVATIONS: 'inventoryReservations',
    WORK_ORDERS: 'workOrders',
    TRIPS: 'trips',
    BID_ORDERS: 'bidOrders',
    OUTSOURCING_ORDERS: 'outsourcingOrders',
    INVENTORY: 'inventory',
    PROJECTS: 'projects',
    MEDICAL_LICENSES: 'medical_license'
}

export const USER_TYPES = {
    EMPLOYEE: 'EMPLOYEE',
    CLIENT: 'CLIENT',
    ADMIN: 'ADMIN',
    REGISTER: 'REGISTER'
}

export const INVENTORY_TYPES = {
    VEHICLE: 'VEHICLE',
    TOOL: 'TOOL'
}

export const INVENTORY_RESERVE_STATUS = {
    ACCEPTED: 'ACCEPTED',
    TAKEN_OUT: 'TAKEN_OUT',
    RETURNED: 'RETURNED',
    DELEGATED: 'DELEGATED'
}

export const userTypesMap = {
    'CLIENT': 'Cliente',
    'EMPLOYEE': 'Empleado',
    'CONSTRUCTION': 'Obra'
}

export const areaWorkOrderMap = {
    'MA': 'Medio Ambiente',
    'SA': 'Saneamiento',
    'C': 'Civil',
    'A': 'Arquitectura',
    'I': 'Industrial',
    'SAT': 'Servicio de Asistencia Técnica',
    'HD': 'Hidrología e Hidráulica',
    'MyT': 'Mensura y Topografía',
}

export const categorySDBidOrderMap = {
    'SA': 'Saneamiento',
    'HI': 'Hidrología',
    'CI': 'Civil',
    'AR': 'Arquitectura',
    'TM': 'Topografía y Mensura',
    'AM': 'Ambiental',
    'AT': 'Servicio Asistencia Técnica',
    'MA': 'Monitoreo Ambiental',
    'LI': 'Licitaciones',
    'VI': 'Vial',
    'L': 'Loteos',
    'DT': 'Dirección de Obra',
    'GAS': 'Gas',
    'GES': 'Gestiones y Trámites',
}

export const categoryARCASABidOrderMap = {
    'OB': 'Obra',
    'PR': 'Proyecto',
    'SE': 'Servicios',
    'EQ': 'Equipos',
}

export const companyBidOrderMap = {
    'Arcasa': 'Arcasa',
    'SD': 'SD'
}

export const messageType = {
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
    FILE: 'FILE'
}

export const procedureStateType = {
    PENDING: 'PENDING',
    FINISHED: 'FINISHED'
}

export const MenuAdmin = {
    USERS: '',
    REGISTERS: 'registros',
    SURVEYS: {
        STATISTICS: 'estadisticas',
        SURVEYS_USERS: 'encuestas_usuarios',
        TEMPLATES: 'plantillas'
    },
    INVENTORY: {
        HOME: 'inventario/',
        NEW_VEHICLE: 'inventario/nuevo_vehiculo',
        EDIT_VEHICLE: 'inventario/editar_vehiculo',
        NEW_TOOL: 'inventario/nueva_herramienta',
        EDIT_TOOL: 'inventario/editar_herramienta'
    },
    INVENTORY_HISTORICAL: 'movilidades_historicos',
    LOGOUT: 'LOGOUT',
}

export const MenuClient = {
    CHAT: '',
    HISTORICAL_CHAT: 'chat_historicos',
    INVENTORY_HISTORICAL: 'movilidades_historicos',
    LOGOUT: 'LOGOUT'
}

export const MenuEmployee = {
    // CHAT: '',
    //WORKS: 'trabajos',
    WORKS: {
        WORKS: '',
        ARCASA: 'trabajos_arcasa',
        SD: 'trabajos_sd',
        RESUME: 'works_resumen',
        CALENDAR: 'works_calendar',
        TRIPS: 'works_trips',
    },
    RESUME: {
        SD: 'SD',
        ARCASA: 'Arcasa'
    },
    HISTORICAL_CHAT: 'chat_historicos',
    INVENTORY_HISTORICAL: 'movilidades_historicos',
    LOGOUT: 'LOGOUT',
    BID: {
        ARCASA: 'cotizaciones_arcasa',
        SD: 'cotizaciones_sd',
    },
    OUTSOURCING: 'proveedores',
    REGISTERS: 'registros',
    EDIT_WORK: 'editar_trabajo/:workId',
    CLIENTS: 'clientes',
}

export const MenuRegister = {
    USERS: '',
    REGISTERS: 'registros',
    PROJECTS: 'proyectos',
    MEDICAL_LICENSES: 'licencias_medicas',
    LOGOUT: 'LOGOUT',
}

export const UsersWithPermissions = ['aldom.4.93@gmail.com', 'carlosdestefanis@sdingenieria.com.ar']

export const VALID_USERS_IDS = ['61hklr8du5VSYHHTrKJOhQIqHrh2', 'SkTxfuVE1NbRu4qSWx1sfMAftMk1', 'En4fdbdLsbTo2TFZGIkxrvGNniz1', '1pXE4umjBWNoGebkaF9QGvInKPP2',
    '1r9FDjiiJNQECVtrm96tCP6btpo1', 'doAhgUE9oyWoyKy3n2yd4TrFXnj1', 'AdJroYYDsthJUw5bylE26RWH3JY2', 'uFalY5X65Nbnhp360hZtnyYzoaK2', 'UOGyrHJuhjMjW5wXrt54LDwVukX2',
    'e1uGfw1yIdZw2Joe8tV1q2TMFeJ2', '10IBknrdHNaqmWHXaKuHJzn5S8T2', 'tCo6L61OLgSUk73xl3YFbXLy6FJ2', 'SK4gGdH9DEbMgmv8eXIS7SI27K12', '8MCIabnvMKXwrkAphfKfUzh4vlY2']

export const SurveysTypes = {
    'EMPTY': '----',
    'PL01': 'Encuesta SAT',
    'PL02': 'Encuesta satisfaccion servicios de consultoria',
    'PL03': 'Encuesta satisfaccion servicios electromecanicos'
}

export const billingBidOrderMap = {
    'Monotributo': 'Monotributo',
    'Empresa': 'Empresa'
}

export const WEEK_DAYS_WORK_HOURS = [
    { day: 'Lunes', hours: 9 },
    { day: 'Martes', hours: 9 },
    { day: 'Miércoles', hours: 9 },
    { day: 'Jueves', hours: 9 },
    { day: 'Viernes', hours: 8 },
    { day: 'Sábado', hours: 0 },
    { day: 'Domingo', hours: 0 }
]

export const PROJECT_DETECTION_RANGE_KM = 0.2

export const OPERATOR_CATEGORIES = {
    HELPER: 'Ayudante',
    HALF_OFFICIAL: 'Medio oficial',
    OFFICIAL: 'Oficial',
    SPECIALIZED_OFFICIAL: 'Oficial especializado'
}
